import React from 'react';
import { STRINGS } from '../utils/constants';

const StateShell = ({ icon, title, subtitle, action, tone = 'default' }) => (
  <div className={`glass-card dashboard-state state-${tone}`} role="status" aria-live="polite">
    <div className="dashboard-state__icon">
      <i className={`fa ${icon}`} aria-hidden="true" />
    </div>
    <h3 className="dashboard-state__title">{title}</h3>
    {subtitle && <p className="dashboard-state__subtitle">{subtitle}</p>}
    {action && <div className="dashboard-state__action">{action}</div>}
  </div>
);

export const LoadingState = () => (
  <StateShell
    icon="fa-spinner fa-spin"
    title={STRINGS.loadingTitle}
    subtitle={STRINGS.loadingSubtitle}
    tone="loading"
  />
);

export const IdleState = () => (
  <StateShell
    icon="fa-bar-chart"
    title={STRINGS.noDataTitle}
    subtitle={STRINGS.noDataSubtitle}
    tone="idle"
  />
);

export const EmptyState = () => (
  <StateShell
    icon="fa-inbox"
    title={STRINGS.emptyTitle}
    subtitle={STRINGS.emptySubtitle}
    tone="empty"
  />
);

export const ErrorState = ({ message, onRetry }) => (
  <StateShell
    icon="fa-exclamation-triangle"
    title={STRINGS.errorTitle}
    subtitle={message || STRINGS.errorSubtitle}
    tone="error"
    action={
      onRetry ? (
        <button type="button" className="fetch-data-btn" onClick={onRetry}>
          <i className="fa fa-refresh" /> {STRINGS.retry}
        </button>
      ) : null
    }
  />
);
